<template>
  <FloatFrameMarginResizeWrapper
    v-show="!preview && renderTools && resizeMarginHover.id &&
      !['reheight_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)
    "
    :class="{ active: resize, [resizeMarginHover.direction]: true }"
    :style="`z-index: ${ (cellActive.id == resizeMarginHover.parent_id || slideContainerActive.id == resizeMarginHover.parent_id) ? 6 : 5}; pointer-events: none;`"
    id="floatFrameResizeMargin"
    :position="resizeMarginHover.position"
  >
    <FloatFrameMarginResizeContainer  class="widget-margin-container" :style="`height: ${heightElement}px; z-index: ${ (cellActive.id == resizeMarginHover.parent_id || slideContainerActive.id == resizeMarginHover.parent_id) ? 6 : 5}; pointer-events: none;`"
    >
      <FloatFrameMarginResizeContent
        class="center-hv d-flex justify-content-center"
        v-if="detectDevice == 'desktop'"
      >
        <ToolIconWrapper class="d-flex justify-content-center" :style="`gap: ${resizeMarginHover.other_id ? 0 : 170}px; min-width: inherit;`">
          <ToolIcon
            class="mx-15 cursor-pointer add-btn btn-hover"
            :style="{'padding': resizeMarginHover.type != 'grid' ? '0px 6px' : '0px 9px'}"
            style="cursor: pointer; pointer-events: all;"
            v-b-tooltip.hover="{disabled: resizeMarginHover.type == 'grid'}"
            v-show="resizeMarginHover.is_show_add_btn"
            :title="resizeMarginHover.label_add_btn"
            @click.stop.prevent="addAction"
          >
            <span>
              <i class="fas fa-plus"></i>
            </span>
            <span v-show="resizeMarginHover.type == 'grid'">
              {{ resizeMarginHover.label_add_btn }}
            </span>
          </ToolIcon>
          <div
            class="mx-30"
            v-show="!resizeMarginHover.is_show_add_btn"
          ></div>
          <ToolIcon
            v-if="(resizeMarginHover.type != 'widget' && resizeMarginHover.type != 'slideWidget') || (!resizeMarginHover.is_last && !resizeMarginHover.is_first)"
            class="mx-15 btn-hover"
            id="resize-margin"
            style="cursor: ns-resize; pointer-events: all;"
            :class="{ 'resize-margin': mode == 'remargin_widget' }"
            @mousedown="dragMouseDown"
          >
            <span> <i class="far fa-arrows-alt-v"></i></span>
            <ToolLabel class="px-2 mx-2 lb" v-if="element && mode == 'remargin_widget'" style="">
              {{ $t('engine.floatframeTool.floatframeHover.margin.lblMargin', languageEngine) }}:{{ element.style[attr] }}
            </ToolLabel>
          </ToolIcon>
        </ToolIconWrapper>
      </FloatFrameMarginResizeContent>
    </FloatFrameMarginResizeContainer>
  </FloatFrameMarginResizeWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { SECTION, WIDGET, SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

import {
  FloatFrameMarginResizeWrapper,
  FloatFrameMarginResizeContainer,
  FloatFrameMarginResizeContent,
  ToolIcon,
  ToolIconWrapper,
  ToolLabel,
} from "./FloatFrameResizeMargin.styled";
export default {
  components: {
    FloatFrameMarginResizeWrapper,
    FloatFrameMarginResizeContainer,
    FloatFrameMarginResizeContent,
    ToolIcon,
    ToolLabel,
    ToolIconWrapper,
  },
  data() {
    return {
      resize: false,
      allHeightContent: 0,
    };
  },
  props: {
    // component_id: {},
    // grid_key: {},
    // parent_key: {},
    // direction: {
    //   default: "top",
    // },

    // is_last: {},
    // componentsKey: {
    //   type: String,
    //   default: "componentsID",
    // },
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  computed: {
    ...mapGetters({
      detectDevice: "detectDevice",
      preview: "designIframe/preview",
      components: "designIframe/metadata/components",
      mode: "designIframe/mode",
      renderTools: "designIframe/frame/renderTools",
      resizeMarginHover: "designIframe/frame/resizeMarginHover",
      languageEngine: "designIframe/userPreference/languageEngine",
      cellActive: "designIframe/frame/cellActive",
      slideContainerActive: "designIframe/frame/slideContainerActive",
      limit: "designIframe/page/limit",
    }),
    element() {
      return this.resizeMarginHover.id && this.components[this.resizeMarginHover.id];
    },
    attr() {
      switch (this.resizeMarginHover.direction) {
        case "top":
          return "marginTop";
        default:
          return "marginBottom";
      }
    },
    section_id() {
      return this.resizeMarginHover.other_id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.resizeMarginHover.other_id)
      );
    },
    heightElement() {
      if (this.resizeMarginHover.height) {
        return this.resizeMarginHover.height
      } else if (this.element && this.element.style[this.attr]) {
        return this.element.style[this.attr]
      } else {
        return 1
      }
    },
    parentElement() {
      return this.resizeMarginHover.parent_id && this.components[this.resizeMarginHover.parent_id]
    },
    checkAllWidgetAlignX() {
      let alignX = this.parentElement.style.alignX
      if (this.parentElement.componentsID.length > 0) {
        let arrayWidgetAlignX = [];
        this.parentElement.componentsID.map(id => {
          let widgetHorizontal = undefined;
          if (this.components[id].type == "SECTION_WIDGET_TEXT") {
            widgetHorizontal = this.components[id].style.positionX
          } else if (
            this.components[id].type == "SECTION_WIDGET_COUNTER"
            || this.components[id].type == "SECTION_WIDGET_FORM"
            || this.components[id].type == "SECTION_WIDGET_CONTACT"
            || this.components[id].type == "SECTION_WIDGET_FAQ"
            || this.components[id].type == "SECTION_WIDGET_QUOTATION_FORM"
          ) {
            widgetHorizontal = null
          } else if ('alignX' in this.components[id].style) {
            widgetHorizontal = this.components[id].style.alignX
          } else if ('positionX' in this.components[id].style) {
            widgetHorizontal = this.components[id].style.positionX
          }
          if (widgetHorizontal != null) {
            arrayWidgetAlignX.push(widgetHorizontal);
          }
        })
        alignX = arrayWidgetAlignX.length > 0 ? arrayWidgetAlignX.reduce((prevAlignX, currentAlignX) => {
          if (prevAlignX && currentAlignX) {
            if(prevAlignX == currentAlignX) {
              return prevAlignX
            } else {
              return 'center'
            }
          } else {
            return 'center'
          }
        }) : this.parentElement.style.alignX
      }
      return alignX
    },
    gridId() {
      const type = this.resizeMarginHover.type;
      return type == 'widget' ? this.resizeMarginHover.other_id : (type == 'grid' ? this.resizeMarginHover.id : null)
    },
    gridComponent() {
      return this.gridId && this.components[this.gridId]
    },
    parentOfGridId() {
      return this.gridId && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.gridId)
      );
    },
    parentOfGridComponent() {
      return this.parentOfGridId && this.components[this.parentOfGridId]
    },
    parentOfGridName() {
      if (this.parentOfGridId) {
        if (this.parentOfGridId.substring(0, SECTION.prefixKey.length) == SECTION.prefixKey) {
          return SECTION.name
        } else if (this.parentOfGridId.substring(0, WIDGET.prefixKey.length) == WIDGET.prefixKey) {
          return WIDGET.name
        }
      }
      return null;
    },
    parentOfGridFocusId() {
      if (this.parentOfGridId) {
        if (this.parentOfGridComponent.type == 'SECTION_WIDGET_TAB_ITEM') {
          return Object.keys(this.components).find((key) =>
            this.components[key].componentsID && this.components[key].componentsID.includes(this.parentOfGridId)
          );
        } else {
          return this.parentOfGridId
        }
      }
      return null;
    }
  },
  methods: {
    addAction() {
      const element = document.getElementById(`comp-${this.resizeMarginHover.id}`);
      const rect = element.getBoundingClientRect();
      const cellWidth = parseInt(rect.width);

      this.$store.dispatch("designIframe/component/elActive", {
        elementID: ["component", this.resizeMarginHover.parent_id],
      });
      if (this.resizeMarginHover.type == 'widget') {
        if (this.parentOfGridName == WIDGET.name) {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.resizeMarginHover.parent_id,
            parent_id: this.gridId,
            widget_key: this.parentOfGridFocusId,
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
        } else if (this.parentOfGridName == SECTION.name) {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.resizeMarginHover.parent_id,
            parent_id: this.gridId,
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: this.section_id,
            name: this.section_id,
          });
        }
        
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        
        this.$store.dispatch("design/setMode", {
          mode: `add_${this.resizeMarginHover.type}`,
        });
      }

      if(this.resizeMarginHover.type == 'grid') {
        const gridCountInSection = this.parentOfGridComponent.componentsID.length;
        if(!this.limit.grid || gridCountInSection < this.limit.grid) {
          this.$store.commit("designIframe/setStatePath", {
            value: {
              gridID: this.gridId,
              parentID: this.parentOfGridId,
              direction: this.resizeMarginHover.direction,
              isFirst: this.resizeMarginHover.is_first,
              isLast: this.resizeMarginHover.is_last
            },
            path: `/component/addComponent/${this.resizeMarginHover.type}`,
          });
          this.$store.dispatch("design/setMode", {
            mode: `add_${this.resizeMarginHover.type}`,
          });
        }
        else {
          this.$store.dispatch("design/setModal", {
            name: "modal-alert-limit-grid",
            payload: {},
          });
        }
      } else if (this.resizeMarginHover.type == 'slideWidget') {
        
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.resizeMarginHover.parent_id,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        const indexSlidePage = this.components[this.section_id].componentsID.indexOf(this.resizeMarginHover.other_id)
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.section_id,
          index: indexSlidePage,
        });

        this.$store.commit("designIframe/setStatePath", {
          value: {
            slideWidgetID: this.resizeMarginHover.id,
            slideSectionID: this.section_id,
            slidePageID: this.resizeMarginHover.other_id,
            slideContainerID: this.resizeMarginHover.parent_id,
            direction: this.resizeMarginHover.direction,
            attribute: this.componentsKey,
            slideContainerAlign: this.checkAllWidgetAlignX,
          },
          path: `/component/addComponent/${this.resizeMarginHover.type}`,
        });
        this.resizeMarginHover.type = "widget";
        this.$store.dispatch("design/setMode", {
          mode: `add_${this.resizeMarginHover.type}`,
        });
      } else { // widget
        this.$store.commit("designIframe/setStatePath", {
          value: {
            widgetID: this.resizeMarginHover.id,
            cellID: this.resizeMarginHover.parent_id,
            direction: this.resizeMarginHover.direction,
            attribute: this.componentsKey,
            cellWidth,
            cellAlign: this.checkAllWidgetAlignX,
          },
          path: `/component/addComponent/${this.resizeMarginHover.type}`,
        });
        this.$store.dispatch("design/setMode", {
          mode: `add_${this.resizeMarginHover.type}`,
        });
      }
    },
    dragMouseDown(e) {
      // if(!this.resizeMarginHover.is_last && this.resizeMarginHover.direction != 'bottom') {
      this.resize = true;

      e = e || window.event;
      this.$store.dispatch("design/setMode", {
        mode: "remargin_widget",
      });
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
      if (this.resizeMarginHover.type == 'widget') {
        this.$store.dispatch("designIframe/frame/setCellActive", {
          component_id: this.resizeMarginHover.parent_id,
          parent_id: this.resizeMarginHover.other_id,
        });
        this.$store.dispatch("designIframe/frame/setSectionActive", {
          component_id: this.section_id,
          name: this.section_id,
        }); 
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
      } else if (this.resizeMarginHover.type == 'slideWidget') {
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.resizeMarginHover.parent_id,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        const indexSlidePage = this.components[this.section_id].componentsID.indexOf(this.resizeMarginHover.other_id)
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.section_id,
          index: indexSlidePage,
        });
      }
    },

    elementDrag(e) {
      const limit = 400;
      if (this.element) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        this.pos1 = this.pos3 - e.clientX;
        this.pos2 = this.pos4 - e.clientY;
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        
        let newMargin = this.element.style[this.attr] - this.pos2 * 2;

        if (this.resizeMarginHover.type == 'slidePage' && this.resizeMarginHover.direction == 'bottom') {
          const element = document.getElementById(`comp-${this.resizeMarginHover.id}`);
          let rect = element.getBoundingClientRect();
          const slidePageHeight = parseInt(rect.height);
          const oldMargin = this.element.style[this.attr];
          newMargin = newMargin <= limit ? newMargin : limit
          newMargin = newMargin >= 0 ? newMargin : 0
          let newHeight = slidePageHeight + newMargin - oldMargin

          this.element.style[this.attr] = newMargin;
          this.components[this.resizeMarginHover.parent_id].style.height = newHeight;

        } else {
          newMargin =  newMargin <= limit ? newMargin : limit
          newMargin = newMargin >= 0 ? newMargin : 0
          this.element.style[this.attr] = newMargin;
        }
        
        if (this.resizeMarginHover.type == 'grid') {
          if ((this.resizeMarginHover.is_first && this.resizeMarginHover.direction == 'top') || (this.resizeMarginHover.is_last && this.resizeMarginHover.direction == 'bottom')) { // first grid top margin
            this.components[this.resizeMarginHover.parent_id].style[this.attr] = newMargin // Update Margin Top Section
          } else { // Grid Margin Between Case (Drag on TOP direction)
            const indexGrid = this.components[this.resizeMarginHover.parent_id].componentsID.indexOf(this.resizeMarginHover.id)
            this.components[this.components[this.resizeMarginHover.parent_id].componentsID[indexGrid-1]].style.marginBottom = newMargin; // Update Previous Grid Bottom Margin
          }
        }
        
        this.$nextTick(() => {
          this.resetComponentHoverPosition();
          this.$store.dispatch("designIframe/frame/reRenderFrame");
        });
      }
    },

    closeDragElement() {
      this.resize = false;
      this.$store.dispatch("design/setMode", {});
      // stop moving when mouse button is released:
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      document.onmouseup = null;
      document.onmousemove = null;
    },
    resetComponentHoverPosition() {
      this.$store.dispatch("designIframe/component/setResizeMarginAction", {
        component_id: this.resizeMarginHover.id,
        direction: this.resizeMarginHover.direction
      });
    },
    mouseLeaveElement() {
      if (this.mode == 'remargin_grid' || this.mode == 'remargin_widget') return;
      this.$store.dispatch("designIframe/frame/setResizeMarginHover", {});
    },
    activeParent() {
      // this.$store.dispatch("designIframe/frame/setParentWidgetActive", {
      //   component_id: this.resizeMarginHover.parent_id
      // });
      if (this.resizeMarginHover.type == 'widget') { // margin Widget
        this.$store.dispatch("designIframe/frame/setWidgetActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetHover", {});

        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.resizeMarginHover.parent_id],
        });
        if (this.parentOfGridName == WIDGET.name) {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.resizeMarginHover.parent_id,
            parent_id: this.gridId,
            widget_key: this.parentOfGridFocusId,
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
        } else if (this.parentOfGridName == SECTION.name) {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.resizeMarginHover.parent_id,
            parent_id: this.gridId,
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: this.section_id,
            name: this.section_id,
          });
        }
        
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
      } else if (this.resizeMarginHover.type == 'slideWidget') { 
        this.$store.dispatch("designIframe/frame/setWidgetActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetHover", {});

        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.resizeMarginHover.parent_id],
        });
        
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.resizeMarginHover.parent_id,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        const indexSlidePage = this.components[this.section_id].componentsID.indexOf(this.resizeMarginHover.other_id)
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.section_id,
          index: indexSlidePage,
        });
      } else if (this.resizeMarginHover.type == 'slidePage') {
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.resizeMarginHover.parent_id, this.resizeMarginHover.id],
        });
        
        const indexSlidePage = this.components[this.resizeMarginHover.parent_id].componentsID.indexOf(this.resizeMarginHover.id)
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.resizeMarginHover.parent_id,
          index: indexSlidePage,
        });

        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetHover", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      } else { // margin Grid
        if (this.parentOfGridName == WIDGET.name) {
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {
            grid_id: this.gridId,
            cell_id: this.resizeMarginHover.parent_id,
            component_id: this.parentOfGridFocusId,
          });
        } else if (this.parentOfGridName == SECTION.name) {
          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: this.resizeMarginHover.parent_id,
            name: this.resizeMarginHover.parent_id,
          });
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
        }
        
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setWidgetHover", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

        let noneSetting = false;
        SECTION_TYPE_NONE_SETTING.find((type) => {
          Object.entries(this.components).forEach((item) => {
            if (type === item[1].type && item[1].id === this.resizeMarginHover.parent_id) {
              noneSetting = true;
            }
          });
        });
        if (noneSetting) {
          this.$store.dispatch("design/component/elActive", {});
        } else {
          this.$store.dispatch("design/component/elActive", {
            elementID: ["component", this.resizeMarginHover.parent_id],
          });
        }
      }
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        if(this.mode == 'remargin_grid' || this.mode == 'remargin_widget') this.closeDragElement()
      }
    },
  },
  watch: {
    mode() {
      this.$nextTick(function () {
        this.resetComponentHoverPosition();
      });
    },
  },
};
</script>

<style lang="scss">
  .icon-hover-label {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    transition: ease-out 0.3s;
    .icon-label {
      // position: absolute;
      // top: 0px;
      // left: 35%;
      white-space: nowrap;
      pointer-events: none;
      // width: 40px;
      opacity: 0;
      transition: ease-out 0.3s;
    }
    &:hover {
      border-radius: 20px;
      width: 100%;
      .icon-wrapper {
        left: 20%;
      }
      .icon-label {
        opacity: 1;
        position: static;
      }
    }
  }
</style>